module.exports = __webpack_public_path__ + "img/Daily-Downloads-of-Selected-Packages-1-768x658.dd5ae232.png";